import { ObjectId } from "t5-common";

export class StatusTitle {
    id: ObjectId;
    description: string;
    color: string;
    available: number;

    constructor(status: IStatusTitleApiIn){
        this.id = status._id ?? status.id;
        this.description = status.description;
        this.color = status.color;
        this.available = status.available;
    }

    toApiOut(): IStatusTitleApiOut {
        return {
            id: this.id,
            description: this.description,
            color: this.color,
            available: this.available
        };
    }
}

export interface IStatusTitleApiIn {
    _id?: ObjectId;
    id?: ObjectId
    description: string;
    color: string;
    available: number;
}

export interface IStatusTitleApiOut {
    id: ObjectId;
    description: string;
    color: string;
    available: number;
}
